import styled from 'styled-components';
import Box from '../index';

const Col = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export default Col;
